import { useSuspenseQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from 'src/constants';
import {
  SearchQueryFactory,
  type FilterKindEnum,
  type SearchParameters,
} from 'app/domain';
import useApi from '../useApi';

const queryFactory = new SearchQueryFactory();

const useFilter = (
  filterKind: FilterKindEnum,
  searchParameters: SearchParameters
) => {
  const { filtersService } = useApi();
  const query = queryFactory.fromSearchParameters(searchParameters);

  const { data } = useSuspenseQuery({
    queryKey: [...QUERY_KEYS.filters, filterKind, query],
    queryFn: () => filtersService.getByType(filterKind, query),
  });

  return { filterGroups: data };
};

export default useFilter;
